import * as React from 'react'
import ModalLayout from '@/modules/drivers/modals/shared/ModalLayout'
import { EditCompanyForm } from './EditCompanyForm'
import { FaIcon, faClose } from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

interface EditCompanyModalProps {
  isOpen: boolean
  close: () => void
  editedCompanyId: string | null
}

const EditCompanyModal: React.FC<EditCompanyModalProps> = ({ isOpen, close, editedCompanyId }) => {
  const { t } = useLocalize()

  if (!isOpen || !editedCompanyId) return null

  return (
    <ModalLayout>
      <div className="tw-relative tw-flex tw-max-h-[90vh] tw-w-full tw-max-w-[900px] tw-flex-col tw-rounded-lg tw-bg-white">
        <div className="tw-border-b tw-border-base-300 tw-px-4 tw-py-4">
          <div className="tw-flex tw-items-center tw-justify-between">
            <p className="tw-text-xl tw-font-semibold tw-text-content-base">
              {t('addCompany.editCompany')}
            </p>
            <FaIcon
              icon={faClose}
              className="tw-h-5 tw-w-5 tw-cursor-pointer"
              onClick={close}
            />
          </div>
        </div>

        <div className="tw-flex-1 tw-overflow-y-auto tw-px-4 tw-py-6">
          <EditCompanyForm
            editedCompanyId={editedCompanyId}
            onSuccess={close}
            onCancel={close}
          />
        </div>
      </div>
    </ModalLayout>
  )
}

export default EditCompanyModal
